export enum VatSystemCode {
  ss = 'SS',
  rs = 'RS',
  rnm = 'RNM',
  rnt = 'RNT'
}
